module.exports = __webpack_public_path__ + "static/media/safe-wallet-logo.77d445d2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/safe-wallet-logo.gif
// module id = 6475
// module chunks = 0